import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/app/App';
import { initializeFirebaseAnalytics } from '@/lib/firebase/analytics';

import '@/styles/tokens.css';
import '@/styles/utilities.css';
import '@/styles/globals.css';

void initializeFirebaseAnalytics();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
